import { render } from "./ModalMapaMenus.vue?vue&type=template&id=225e25e3&scoped=true"
import script from "./ModalMapaMenus.vue?vue&type=script&lang=js"
export * from "./ModalMapaMenus.vue?vue&type=script&lang=js"

import "./ModalMapaMenus.vue?vue&type=style&index=0&id=225e25e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225e25e3"]])

export default __exports__